var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20358",
    "data-name": "Group 20358",
    transform: "translate(-220 -2595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7903",
    "data-name": "Rectangle 7903",
    width: 220,
    height: 220,
    transform: "translate(220 2595)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Webinar-amico",
    transform: "translate(235.49 2632.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    transform: "translate(0 48.646)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2-2",
    "data-name": "freepik--floor--inject-2",
    cx: 94.51,
    cy: 56.223,
    rx: 94.51,
    ry: 56.223,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    transform: "translate(17.968 54.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-2",
    d: "M302.019,267.661l31.155-17.972a1.355,1.355,0,0,0,0-2.569L288.217,221.11a4.92,4.92,0,0,0-4.455,0L252.6,239.082a1.355,1.355,0,0,0,0,2.569l44.958,26.009A4.92,4.92,0,0,0,302.019,267.661Z",
    transform: "translate(-174.468 -220.577)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-2",
    "data-name": "freepik--shadow--inject-2",
    d: "M106.408,346.751,59.723,319.837c-1.314-.758-1.314-1.985,0-2.748l64.951-37.5a5.265,5.265,0,0,1,4.765,0L176.124,306.5c1.314.758,1.314,1.985,0,2.748l-64.955,37.5a5.265,5.265,0,0,1-4.761,0Z",
    transform: "translate(-58.143 -255.81)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1068",
    "data-name": "Ellipse 1068",
    cx: 13.175,
    cy: 7.608,
    rx: 13.175,
    ry: 7.608,
    transform: "translate(0 74.256)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37331",
    "data-name": "Path 37331",
    d: "M242.269,434.292l.044-.052,2.351-2.581h0v-.02a.226.226,0,0,1,.044-.044l.024-.028h0a1.183,1.183,0,0,1,1.469,0,4.062,4.062,0,0,1,1.842,3.177,1.2,1.2,0,0,1-.711,1.267H247.3l-.131.028h-.032l-3.4.743a.83.83,0,0,1-.6-.127,2.331,2.331,0,0,1-1.052-1.823.881.881,0,0,1,.179-.54Z",
    transform: "translate(-168.689 -347.635)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37332",
    "data-name": "Path 37332",
    d: "M295.074,374.41,245.53,403.044l-6.862,1.4a.21.21,0,0,1-.226-.306l2.148-3.943,49.548-28.638C291.493,370.773,296.135,373.8,295.074,374.41Z",
    transform: "translate(-166.475 -311.527)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-3",
    "data-name": "freepik--shadow--inject-2",
    d: "M310.1,395.947c.5,1.35,1.938,2.192,4.344,2.506l42.917-24.992,4.455-4.515a.345.345,0,0,0-.353-.572l-8.2,2.716Z",
    transform: "translate(-209.693 -309.675)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-2",
    transform: "translate(20.91 42.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-2-2",
    "data-name": "freepik--books--inject-2",
    transform: "translate(78.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-2",
    transform: "translate(0 8.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37333",
    "data-name": "Path 37333",
    d: "M334.359,253.763l-27.633,15.605L264.29,245.015l27.629-15.605Z",
    transform: "translate(-263.146 -221.746)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37334",
    "data-name": "Path 37334",
    d: "M334.359,253.763l-27.633,15.605L264.29,245.015l27.629-15.605Z",
    transform: "translate(-263.146 -221.746)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37335",
    "data-name": "Path 37335",
    d: "M370.337,296.626l26.7-15.157c-.663-1.882-.615-2.454.139-4.96l-26.541,15.018S370.155,291.476,370.337,296.626Z",
    transform: "translate(-327.059 -250.144)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37336",
    "data-name": "Path 37336",
    d: "M370.718,286.428a5.349,5.349,0,0,0-2.438,4.2v3.3c0,1.545,1.092,2.172,2.438,1.4l26.335-14.962v-1.215l-26,14.692c-.794.461-1.465.087-1.461-.842l.02-2.923a3.224,3.224,0,0,1,1.469-2.521l25.969-14.692V271.49Z",
    transform: "translate(-325.844 -247.117)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37337",
    "data-name": "Path 37337",
    d: "M370.718,286.428a5.349,5.349,0,0,0-2.438,4.2v3.3c0,1.545,1.092,2.172,2.438,1.4l26.335-14.962v-1.215l-26,14.692c-.794.461-1.465.087-1.461-.842l.02-2.923a3.224,3.224,0,0,1,1.469-2.521l25.969-14.692V271.49Z",
    transform: "translate(-325.844 -247.117)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37338",
    "data-name": "Path 37338",
    d: "M332.619,234.463,290.183,210.11l-26.331,14.958a5.357,5.357,0,0,0-2.442,4.2v3.284a1.7,1.7,0,0,0,.715,1.568l42.436,24.349a1.688,1.688,0,0,1-.715-1.565v-3.288a5.361,5.361,0,0,1,2.438-4.2Z",
    transform: "translate(-261.41 -210.11)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37339",
    "data-name": "Path 37339",
    d: "M332.619,234.463,290.183,210.11l-26.331,14.958a5.357,5.357,0,0,0-2.442,4.2v3.284a1.7,1.7,0,0,0,.715,1.568l42.436,24.349a1.688,1.688,0,0,1-.715-1.565v-3.288a5.361,5.361,0,0,1,2.438-4.2Z",
    transform: "translate(-261.41 -210.11)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37340",
    "data-name": "Path 37340",
    d: "M304.557,276.7a4.959,4.959,0,0,0-.715,2.383V282.4a1.688,1.688,0,0,0,.715,1.565l-42.432-24.365a1.691,1.691,0,0,1-.715-1.568v-3.284a4.96,4.96,0,0,1,.715-2.383Z",
    transform: "translate(-261.41 -235.583)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37341",
    "data-name": "Path 37341",
    d: "M304.557,276.7a4.959,4.959,0,0,0-.715,2.383V282.4a1.688,1.688,0,0,0,.715,1.565l-42.432-24.365a1.691,1.691,0,0,1-.715-1.568v-3.284a4.96,4.96,0,0,1,.715-2.383Z",
    transform: "translate(-261.41 -235.583)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37342",
    "data-name": "Path 37342",
    d: "M276.746,260.54c-.794,3.435-.794,4.765,0,7.294L278.763,269c-.794-2.518-.794-3.86,0-7.294Z",
    transform: "translate(-270.297 -240.515)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37343",
    "data-name": "Path 37343",
    d: "M346.836,300.82c-.794,3.435-.794,4.733,0,7.251l2.021,1.167c-.794-2.521-.794-3.82,0-7.251Z",
    transform: "translate(-312.555 -264.801)",
    fill: "#5a4bda"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-2-2",
    "data-name": "freepik--book--inject-2",
    transform: "translate(5.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37344",
    "data-name": "Path 37344",
    d: "M348.4,233.433l-27.633,15.605L278.33,224.685l27.629-15.605Z",
    transform: "translate(-277.186 -201.146)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37345",
    "data-name": "Path 37345",
    d: "M348.4,233.433l-27.633,15.605L278.33,224.685l27.629-15.605Z",
    transform: "translate(-277.186 -201.146)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37346",
    "data-name": "Path 37346",
    d: "M384.382,275.858l26.7-15.169c-.663-1.882-.616-2.724.135-5.23l-26.537,15.014S384.207,270.708,384.382,275.858Z",
    transform: "translate(-341.103 -229.109)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37347",
    "data-name": "Path 37347",
    d: "M384.752,265.414a5.361,5.361,0,0,0-2.442,4.2v3.554c0,1.545,1.092,2.172,2.442,1.4l26.335-14.958v-1.215l-26,14.692c-.794.465-1.465.087-1.465-.838l.024-3.177a3.22,3.22,0,0,1,1.465-2.521l25.973-14.692V250.48Z",
    transform: "translate(-339.878 -226.107)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37348",
    "data-name": "Path 37348",
    d: "M384.752,265.414a5.361,5.361,0,0,0-2.442,4.2v3.554c0,1.545,1.092,2.172,2.442,1.4l26.335-14.958v-1.215l-26,14.692c-.794.465-1.465.087-1.465-.838l.024-3.177a3.22,3.22,0,0,1,1.465-2.521l25.973-14.692V250.48Z",
    transform: "translate(-339.878 -226.107)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37349",
    "data-name": "Path 37349",
    d: "M346.659,213.453,304.223,189.1l-26.335,14.958a5.349,5.349,0,0,0-2.438,4.2v3.574a1.688,1.688,0,0,0,.715,1.565L318.6,237.751a1.691,1.691,0,0,1-.715-1.568v-3.554a5.349,5.349,0,0,1,2.438-4.2Z",
    transform: "translate(-275.45 -189.1)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37350",
    "data-name": "Path 37350",
    d: "M318.6,255.661a4.936,4.936,0,0,0-.715,2.383V261.6a1.7,1.7,0,0,0,.715,1.568l-42.432-24.345a1.688,1.688,0,0,1-.715-1.565v-3.574a4.936,4.936,0,0,1,.715-2.382Z",
    transform: "translate(-275.45 -214.543)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37351",
    "data-name": "Path 37351",
    d: "M318.6,255.661a4.936,4.936,0,0,0-.715,2.383V261.6a1.7,1.7,0,0,0,.715,1.568l-42.432-24.345a1.688,1.688,0,0,1-.715-1.565v-3.574a4.936,4.936,0,0,1,.715-2.382Z",
    transform: "translate(-275.45 -214.543)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37352",
    "data-name": "Path 37352",
    d: "M290.776,239.52c-.794,3.435-.794,5.051,0,7.568l2.021,1.167c-.794-2.521-.794-4.134,0-7.568Z",
    transform: "translate(-284.331 -219.499)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37353",
    "data-name": "Path 37353",
    d: "M360.876,279.85c-.794,3.435-.794,4.991,0,7.509l2.021,1.167c-.794-2.518-.794-4.086,0-7.521Z",
    transform: "translate(-326.595 -243.815)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19321",
    "data-name": "Group 19321",
    transform: "translate(5.849 20.021)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37354",
    "data-name": "Path 37354",
    d: "M290.776,239.52c-.794,3.435-.794,5.051,0,7.568l2.021,1.167c-.794-2.521-.794-4.134,0-7.568Z",
    transform: "translate(-290.18 -239.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37355",
    "data-name": "Path 37355",
    d: "M360.876,279.85c-.794,3.435-.794,4.991,0,7.509l2.021,1.167c-.794-2.518-.794-4.086,0-7.521Z",
    transform: "translate(-332.444 -263.836)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-2-3",
    "data-name": "freepik--books--inject-2",
    transform: "translate(0 22.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-2-3",
    "data-name": "freepik--book--inject-2",
    transform: "translate(5.5 7.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37356",
    "data-name": "Path 37356",
    d: "M78.5,324.148l42.921,24.385,62.255-35.738L140.759,288.41Z",
    transform: "translate(-78.5 -279.928)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37357",
    "data-name": "Path 37357",
    d: "M78.5,324.148l42.921,24.385,62.255-35.738L140.759,288.41Z",
    transform: "translate(-78.5 -279.928)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37358",
    "data-name": "Path 37358",
    d: "M123.515,391.941l-41.928-23.92c.711-2.013.655-2.915-.147-5.591l41.753,23.758S123.71,386.438,123.515,391.941Z",
    transform: "translate(-80.273 -324.556)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37359",
    "data-name": "Path 37359",
    d: "M120.041,380.744a5.718,5.718,0,0,1,2.609,4.487v3.8c0,1.656-1.167,2.323-2.609,1.5L78.51,366.83v-1.3l41.178,23.392c.862.5,1.561.1,1.561-.9l-.024-3.411a3.435,3.435,0,0,0-1.565-2.692l-41.15-23.4V357.05Z",
    transform: "translate(-78.506 -321.312)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37360",
    "data-name": "Path 37360",
    d: "M120.041,380.744a5.718,5.718,0,0,1,2.609,4.487v3.8c0,1.656-1.167,2.323-2.609,1.5L78.51,366.83v-1.3l41.178,23.392c.862.5,1.561.1,1.561-.9l-.024-3.411a3.435,3.435,0,0,0-1.565-2.692l-41.15-23.4V357.05Z",
    transform: "translate(-78.506 -321.312)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37361",
    "data-name": "Path 37361",
    d: "M78.51,302.788l62.255-35.738L182.3,290.744a5.718,5.718,0,0,1,2.609,4.487v3.8a1.811,1.811,0,0,1-.762,1.676L121.883,336.44a1.815,1.815,0,0,0,.762-1.676v-3.8a5.722,5.722,0,0,0-2.6-4.487Z",
    transform: "translate(-78.506 -267.05)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37362",
    "data-name": "Path 37362",
    d: "M78.51,302.788l62.255-35.738L182.3,290.744a5.718,5.718,0,0,1,2.609,4.487v3.8a1.811,1.811,0,0,1-.762,1.676L121.883,336.44a1.815,1.815,0,0,0,.762-1.676v-3.8a5.722,5.722,0,0,0-2.6-4.487Z",
    transform: "translate(-78.506 -267.05)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37363",
    "data-name": "Path 37363",
    d: "M187.75,367.315a5.27,5.27,0,0,1,.762,2.553v3.8a1.815,1.815,0,0,1-.762,1.676l62.259-35.738a1.811,1.811,0,0,0,.762-1.676v-3.808a5.309,5.309,0,0,0-.762-2.553Z",
    transform: "translate(-144.369 -305.95)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37364",
    "data-name": "Path 37364",
    d: "M187.75,367.315a5.253,5.253,0,0,1,.762,2.553v3.8a1.82,1.82,0,0,1-.762,1.676L250,339.607a1.817,1.817,0,0,0,.766-1.676v-3.808a5.254,5.254,0,0,0-.762-2.553Z",
    transform: "translate(-144.369 -305.95)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37365",
    "data-name": "Path 37365",
    d: "M325.82,340.36c.846,3.669.834,5.392,0,8.085l-2.16,1.247c.834-2.692.846-4.416,0-8.085Z",
    transform: "translate(-226.311 -311.25)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37366",
    "data-name": "Path 37366",
    d: "M208.336,407.89c.846,3.669.834,5.341,0,8.033l-2.156,1.235c.83-2.692.842-4.368,0-8.029Z",
    transform: "translate(-155.48 -351.965)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19322",
    "data-name": "Group 19322",
    transform: "translate(50.7 29.11)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37367",
    "data-name": "Path 37367",
    d: "M325.82,340.36c.846,3.669.834,5.392,0,8.085l-2.16,1.247c.834-2.692.846-4.416,0-8.085Z",
    transform: "translate(-277.011 -340.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37368",
    "data-name": "Path 37368",
    d: "M208.336,407.89c.846,3.669.834,5.341,0,8.033l-2.156,1.235c.83-2.692.842-4.368,0-8.029Z",
    transform: "translate(-206.18 -381.075)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-2-4",
    "data-name": "freepik--book--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37369",
    "data-name": "Path 37369",
    d: "M64.65,303.378l42.921,24.385,62.255-35.738L126.909,267.64Z",
    transform: "translate(-64.65 -259.444)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37370",
    "data-name": "Path 37370",
    d: "M64.65,303.378l42.921,24.385,62.255-35.738L126.909,267.64Z",
    transform: "translate(-64.65 -259.444)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37371",
    "data-name": "Path 37371",
    d: "M109.689,371.619,67.777,347.691c.711-2.013.655-2.625-.147-5.3l41.753,23.754S109.868,366.108,109.689,371.619Z",
    transform: "translate(-66.447 -304.512)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37372",
    "data-name": "Path 37372",
    d: "M106.191,360.7a5.718,5.718,0,0,1,2.609,4.487v3.506c0,1.656-1.167,2.323-2.609,1.5L64.66,346.494v-1.3l41.178,23.392c.862.5,1.561.1,1.561-.9l-.024-3.121a3.443,3.443,0,0,0-1.565-2.7l-41.15-23.4V337Z",
    transform: "translate(-64.656 -301.262)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37373",
    "data-name": "Path 37373",
    d: "M106.191,360.7a5.718,5.718,0,0,1,2.609,4.487v3.506c0,1.656-1.167,2.323-2.609,1.5L64.66,346.494v-1.3l41.178,23.392c.862.5,1.561.1,1.561-.9l-.024-3.121a3.443,3.443,0,0,0-1.565-2.7l-41.15-23.4V337Z",
    transform: "translate(-64.656 -301.262)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37374",
    "data-name": "Path 37374",
    d: "M64.65,282.738,126.909,247l41.519,23.7a5.726,5.726,0,0,1,2.621,4.495V278.7a1.8,1.8,0,0,1-.766,1.676l-62.255,35.718a1.82,1.82,0,0,0,.762-1.676v-3.486a5.73,5.73,0,0,0-2.6-4.491Z",
    transform: "translate(-64.65 -247)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37375",
    "data-name": "Path 37375",
    d: "M64.65,282.738,126.909,247l41.519,23.7a5.726,5.726,0,0,1,2.621,4.495V278.7a1.8,1.8,0,0,1-.766,1.676l-62.255,35.718a1.82,1.82,0,0,0,.762-1.676v-3.486a5.73,5.73,0,0,0-2.6-4.491Z",
    transform: "translate(-64.65 -247)",
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37376",
    "data-name": "Path 37376",
    d: "M173.9,347.3a5.253,5.253,0,0,1,.762,2.553v3.51a1.82,1.82,0,0,1-.762,1.676L236.155,319.3a1.8,1.8,0,0,0,.766-1.676v-3.5a5.262,5.262,0,0,0-.766-2.553Z",
    transform: "translate(-130.519 -285.93)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37377",
    "data-name": "Path 37377",
    d: "M173.9,347.3a5.253,5.253,0,0,1,.762,2.553v3.51a1.82,1.82,0,0,1-.762,1.676L236.155,319.3a1.8,1.8,0,0,0,.766-1.676v-3.5a5.262,5.262,0,0,0-.766-2.553Z",
    transform: "translate(-130.519 -285.93)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37378",
    "data-name": "Path 37378",
    d: "M311.97,320.32c.846,3.669.834,5.1,0,7.795l-2.16,1.247c.834-2.692.846-4.126,0-7.8Z",
    transform: "translate(-212.461 -291.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37379",
    "data-name": "Path 37379",
    d: "M194.48,387.82c.846,3.669.834,5.059,0,7.751l-2.16,1.243c.834-2.688.846-4.078,0-7.747Z",
    transform: "translate(-141.624 -331.903)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graduation-cap--inject-2",
    transform: "translate(105.581 24.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--graduation-cap--inject-2-2",
    "data-name": "freepik--graduation-cap--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37380",
    "data-name": "Path 37380",
    d: "M307.85,181.948V198.11c0,2.327,2.045,4.654,6.1,6.429,8.132,3.574,21.319,3.574,29.452,0,4.07-1.783,6.1-4.114,6.1-6.449V181.948h0c.048-2.383-1.985-4.725-6.1-6.528-8.132-3.574-21.319-3.574-29.452,0-4.122,1.791-6.151,4.173-6.1,6.528Z",
    transform: "translate(-295.949 -161.336)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37381",
    "data-name": "Path 37381",
    d: "M307.848,181.948c-.048-2.383,1.985-4.725,6.1-6.528,8.132-3.574,21.319-3.574,29.452,0,4.114,1.8,6.143,4.165,6.1,6.528h0v7.382c0-1.831-1.624-3.141-6.433-1.37-7.882,2.9-12.31,7.7-20.347,10.066-6.647,1.958-12.536,1.191-14.875-1.243V181.948Z",
    transform: "translate(-295.943 -161.336)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37382",
    "data-name": "Path 37382",
    d: "M307.85,217.446v1.835c0,2.323,2.045,4.654,6.1,6.425,8.132,3.574,21.319,3.574,29.452,0,4.1-1.791,6.127-4.15,6.1-6.5V217.43c0,2.331-2.029,4.662-6.1,6.449-8.132,3.574-21.319,3.574-29.452,0C309.895,222.1,307.862,219.777,307.85,217.446Z",
    transform: "translate(-295.949 -188.28)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37383",
    "data-name": "Path 37383",
    d: "M343.331,159.478,310.608,144.02,277.88,159.478v2.577L310.608,175.8l32.724-13.743Z",
    transform: "translate(-277.88 -144.02)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37384",
    "data-name": "Path 37384",
    d: "M360.3,199.27v-2.577l32.724-13.743v2.577Z",
    transform: "translate(-327.572 -167.492)",
    fill: "#5a4bda",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37385",
    "data-name": "Path 37385",
    d: "M360.3,196.693l32.255-12.977.469,1.811V182.95Z",
    transform: "translate(-327.572 -167.492)",
    fill: "#5a4bda",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37386",
    "data-name": "Path 37386",
    d: "M310.608,144.02,277.88,159.478l32.728,13.743,32.724-13.743Z",
    transform: "translate(-277.88 -144.02)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37387",
    "data-name": "Path 37387",
    d: "M316.1,192.462c0-.214-.1-5.238.4-6.667s2.359-2.879,6.238-4.848a40.871,40.871,0,0,1,8.716-3.216l.159.715a39.983,39.983,0,0,0-8.545,3.153c-3.645,1.85-5.456,3.22-5.873,4.435-.373,1.084-.377,5-.345,6.413Z",
    transform: "translate(-300.916 -164.344)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37388",
    "data-name": "Path 37388",
    d: "M316.1,192.462c0-.214-.1-5.238.4-6.667s2.359-2.879,6.238-4.848a40.871,40.871,0,0,1,8.716-3.216l.159.715a39.983,39.983,0,0,0-8.545,3.153c-3.645,1.85-5.456,3.22-5.873,4.435-.373,1.084-.377,5-.345,6.413Z",
    transform: "translate(-300.916 -164.344)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37389",
    "data-name": "Path 37389",
    d: "M314.991,234.613c0-3.76-.623-10.495-2.6-12.453h-2.6c-1.985,1.958-2.593,8.692-2.593,12.453h0a1.925,1.925,0,0,0,1.14,1.588,6.083,6.083,0,0,0,5.508,0A1.94,1.94,0,0,0,314.991,234.613Z",
    transform: "translate(-295.557 -191.132)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37390",
    "data-name": "Path 37390",
    d: "M314.991,234.613c0-3.76-.623-10.495-2.6-12.453h-2.6c-1.985,1.958-2.593,8.692-2.593,12.453h0a1.925,1.925,0,0,0,1.14,1.588,6.083,6.083,0,0,0,5.508,0A1.94,1.94,0,0,0,314.991,234.613Z",
    transform: "translate(-295.557 -191.132)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37391",
    "data-name": "Path 37391",
    d: "M310.492,222.16a3.621,3.621,0,0,0-.421.524,3,3,0,0,0,2.017.719c.758.06,1.549.675,1.886,3.76s.993,7.024-.23,8.22-3.951,1.191-5.384.294h0a3.005,3.005,0,0,0,.679.528,6.083,6.083,0,0,0,5.508,0,1.94,1.94,0,0,0,1.144-1.588h0c0-3.76-.623-10.495-2.6-12.453Z",
    transform: "translate(-296.257 -191.132)",
    fill: "#5a4bda",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37392",
    "data-name": "Path 37392",
    d: "M315.987,215.744a1.95,1.95,0,1,1-.57-1.381A1.954,1.954,0,0,1,315.987,215.744Z",
    transform: "translate(-298.5 -186.085)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37393",
    "data-name": "Path 37393",
    d: "M315.987,215.744a1.95,1.95,0,1,1-.57-1.381A1.954,1.954,0,0,1,315.987,215.744Z",
    transform: "translate(-298.5 -186.085)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37394",
    "data-name": "Path 37394",
    d: "M315.326,214.72a1.771,1.771,0,0,1-.473,2.537,1.91,1.91,0,0,1-2.514-.373,1.946,1.946,0,1,0,2.986-2.164Z",
    transform: "translate(-298.656 -186.646)",
    fill: "#5a4bda",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37395",
    "data-name": "Path 37395",
    d: "M353.67,173.078a1.314,1.314,0,0,1,.77-1.072,4.122,4.122,0,0,1,3.721,0,1.314,1.314,0,0,1,.77,1.072v.862a1.31,1.31,0,0,1-.77,1.072,4.122,4.122,0,0,1-3.721,0,1.31,1.31,0,0,1-.77-1.072Z",
    transform: "translate(-323.575 -160.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37396",
    "data-name": "Path 37396",
    d: "M358.184,174.154a1.134,1.134,0,0,0,0-2.148,4.122,4.122,0,0,0-3.721,0,1.135,1.135,0,0,0,0,2.148A4.122,4.122,0,0,0,358.184,174.154Z",
    transform: "translate(-323.59 -160.626)",
    fill: "#37474f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Apple--inject-2",
    transform: "translate(16.224 108.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--apple--inject-2-2",
    "data-name": "freepik--apple--inject-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37397",
    "data-name": "Path 37397",
    d: "M70.762,372.886c2.327-.258,6.381-.635,9.748,4.074,3.836,5.357,2.236,13.1-1.588,16.928-4.821,4.765-13.366,6.476-19.211,2.732-6.472-4.142-8.529-13.727-5.432-18.607s9.177-4.674,10.817-4.285C67.558,374.311,68.955,373.088,70.762,372.886Z",
    transform: "translate(-52.857 -365.712)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37398",
    "data-name": "Path 37398",
    d: "M62.657,409.3c6.516,2.247,14.482-.159,18.77-4.765A12.361,12.361,0,0,1,78.9,408.3c-4.821,4.765-13.366,6.477-19.211,2.732-4.9-3.129-7.255-9.415-6.778-14.39C52.909,398.01,55.486,406.829,62.657,409.3Z",
    transform: "translate(-52.848 -380.115)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19323",
    "data-name": "Group 19323",
    transform: "translate(19.553 8.725)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37399",
    "data-name": "Path 37399",
    d: "M103.182,377.086c1.461-.4,3.84.568,5.313,2.383a14.359,14.359,0,0,1,2.613,8.442c0,5.349-4.559,8.934-5.118,8.577s2.51-4.368-.4-9.216C102.674,382.383,100.784,377.709,103.182,377.086Z",
    transform: "translate(-102.09 -376.997)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19324",
    "data-name": "Group 19324",
    transform: "translate(20.241 9.414)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37400",
    "data-name": "Path 37400",
    d: "M105.518,378.775c1.588.254,3.76,2.383,4.507,4.007s.723,2.835.524,3.077c-.357.429-3.939-2.049-5.162-3.224C103.643,380.963,102.937,378.366,105.518,378.775Z",
    transform: "translate(-103.823 -378.732)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37401",
    "data-name": "Path 37401",
    d: "M85.462,384.053c.695-.794,1.4-1.235,1.985-.334s-1.326,2.78-3.824,2.5-3.574-1.7-3.673-2.5a4.419,4.419,0,0,0,3,1.441A4.07,4.07,0,0,0,85.462,384.053Z",
    transform: "translate(-69.188 -372.023)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37402",
    "data-name": "Path 37402",
    d: "M88.494,368.607a22.61,22.61,0,0,1-.036-6.691c.56-3.236,2.1-5.694,2.577-6.02a6.488,6.488,0,0,1,2.541-.834c1.223-.195,2.819.4,2.5.917s-2.021,1.191-3.816,3.554-3.177,6.588-2.78,8.907A.949.949,0,0,1,88.494,368.607Z",
    transform: "translate(-74.179 -355.024)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37403",
    "data-name": "Path 37403",
    d: "M95.26,355.856l.107-.068h0a7.147,7.147,0,0,1,2.335-.707,3.335,3.335,0,0,1,2.383.5c.115.163-.115.445-1.191.794a6.914,6.914,0,0,1-3.264.246C95.165,356.515,94.907,356.126,95.26,355.856Z",
    transform: "translate(-78.32 -355.036)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37404",
    "data-name": "Path 37404",
    d: "M89.508,368.14c.492-2.915,3.022-5.706,4.844-7.06h0a12.516,12.516,0,0,0-2.013,2.1c-1.8,2.359-3.177,6.588-2.78,8.907a.949.949,0,0,1-.977.167s-.143-.834-.222-2.061C88.614,371.309,89.051,370.828,89.508,368.14Z",
    transform: "translate(-74.259 -358.675)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37405",
    "data-name": "Path 37405",
    d: "M77.34,367.044a5.833,5.833,0,0,1-5.682-1.191c-2.057-1.926-1.453-4.991-1.453-4.991a5.432,5.432,0,0,1,4.944.671A6.42,6.42,0,0,1,77.34,367.044Z",
    transform: "translate(-63.263 -358.354)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37406",
    "data-name": "Path 37406",
    d: "M77.34,367.044a5.833,5.833,0,0,1-5.682-1.191c-2.057-1.926-1.453-4.991-1.453-4.991a5.432,5.432,0,0,1,4.944.671A6.42,6.42,0,0,1,77.34,367.044Z",
    transform: "translate(-63.263 -358.354)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37407",
    "data-name": "Path 37407",
    d: "M70.33,360.892a5.432,5.432,0,0,1,4.944.671,6.431,6.431,0,0,1,2.192,5.5C75.361,363.036,70.33,360.892,70.33,360.892Z",
    transform: "translate(-63.388 -358.372)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37408",
    "data-name": "Path 37408",
    d: "M70.33,360.892a5.432,5.432,0,0,1,4.944.671,6.431,6.431,0,0,1,2.192,5.5C75.361,363.036,70.33,360.892,70.33,360.892Z",
    transform: "translate(-63.388 -358.372)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-2",
    transform: "translate(89.541 110.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-2-2",
    "data-name": "freepik--pen--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-2-3",
    "data-name": "freepik--pen--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37409",
    "data-name": "Path 37409",
    d: "M369.092,362.63a4.07,4.07,0,0,0,1.842,3.177,1.465,1.465,0,0,0,1.056.222.944.944,0,0,1-.2.159l.441-.254h.028l.064-.044a.718.718,0,0,0,.083-.071l.048-.048h0l.044-.052a1.132,1.132,0,0,0,.151-.274.83.83,0,0,0,.032-.091.091.091,0,0,0,0-.044.331.331,0,0,0,.02-.079,1.855,1.855,0,0,0,.052-.461,4.07,4.07,0,0,0-1.839-3.177,1.644,1.644,0,0,0-.826-.254h-.115l-.107.02h-.1l-.075.032h0l-.071.036-.4.218a.846.846,0,0,1,.2-.071A1.469,1.469,0,0,0,369.092,362.63ZM372.126,366h.032Z",
    transform: "translate(-316.83 -361.34)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37410",
    "data-name": "Path 37410",
    d: "M249.23,389.625l2.593,4.527.441-.254,47.253-27.3a.945.945,0,0,0,.2-.159,1.457,1.457,0,0,0,.342-1.032,4.07,4.07,0,0,0-1.842-3.177,1.664,1.664,0,0,0-.822-.25,1.116,1.116,0,0,0-.234.024.849.849,0,0,0-.2.072h-.032Z",
    transform: "translate(-244.566 -361.726)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37411",
    "data-name": "Path 37411",
    d: "M249.708,431.548c-1.017-.588-1.838-.111-1.838,1.06a4.066,4.066,0,0,0,1.839,3.177c1.017.588,1.842.111,1.842-1.064A4.062,4.062,0,0,0,249.708,431.548Z",
    transform: "translate(-243.746 -403.517)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37412",
    "data-name": "Path 37412",
    d: "M274.42,396.52h0l.06-.036a.488.488,0,0,1,.429.064,1.453,1.453,0,0,1,.655,1.132.488.488,0,0,1-.155.4h0l-.079.048-27.971,16.145-1.839-1.064Z",
    transform: "translate(-242.33 -382.515)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37413",
    "data-name": "Path 37413",
    d: "M249.985,435.092l-2.6,1.5-1.838-1.064,3.518-2.029a4.444,4.444,0,0,1,.917,1.592Z",
    transform: "translate(-242.348 -404.846)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37414",
    "data-name": "Path 37414",
    d: "M240.061,437.962h0l2.132-2.343.056-.064a.834.834,0,0,1,1.052,0,2.875,2.875,0,0,1,1.3,2.251.858.858,0,0,1-.5.9h0l-.083.02-3.125.679h0a.489.489,0,0,1-.338-.071,1.314,1.314,0,0,1-.592-1.028.468.468,0,0,1,.1-.342Z",
    transform: "translate(-238.979 -405.973)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37415",
    "data-name": "Path 37415",
    d: "M240.061,437.962h0l2.132-2.343.056-.064a.834.834,0,0,1,1.052,0,2.875,2.875,0,0,1,1.3,2.251.858.858,0,0,1-.5.9h0l-.083.02-3.125.679h0a.489.489,0,0,1-.338-.071,1.314,1.314,0,0,1-.592-1.028.468.468,0,0,1,.1-.342Z",
    transform: "translate(-238.979 -405.973)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37416",
    "data-name": "Path 37416",
    d: "M239.907,440.2a1.306,1.306,0,0,0,.6,1.025.476.476,0,0,0,.334.071h0l1.588-.341c.246-.056.4-.29.4-.663a2.1,2.1,0,0,0-.945-1.644.612.612,0,0,0-.758,0l-.044.048-1.056,1.159h0a.457.457,0,0,0-.111.345Z",
    transform: "translate(-238.944 -407.872)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37417",
    "data-name": "Path 37417",
    d: "M240.5,441.769c-.326-.187-.592-.036-.592.341a1.314,1.314,0,0,0,.592,1.028c.33.187.592.036.592-.341A1.31,1.31,0,0,0,240.5,441.769Z",
    transform: "translate(-238.947 -409.784)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37418",
    "data-name": "Path 37418",
    d: "M334.749,372.753a.449.449,0,0,1,.461.044,1.433,1.433,0,0,1,.651,1.128.453.453,0,0,1-.195.425h0l-16.257,9.4a.488.488,0,0,0,.155-.4,1.453,1.453,0,0,0-.655-1.132.488.488,0,0,0-.429-.064Z",
    transform: "translate(-286.318 -368.194)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37419",
    "data-name": "Path 37419",
    d: "M358.988,373.157a1.453,1.453,0,0,0,.651,1.128.4.4,0,0,0,.651-.377,1.433,1.433,0,0,0-.651-1.128.4.4,0,0,0-.651.377Z",
    transform: "translate(-310.736 -368.178)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37420",
    "data-name": "Path 37420",
    d: "M361.973,364.272h.052l2.716-1.588.064-.036h0a1.191,1.191,0,0,1,1.12.139,3.657,3.657,0,0,1,1.656,2.871,1.16,1.16,0,0,1-.488,1.072h0l-2.748,1.588h0a1.191,1.191,0,0,1-1.148-.127,3.669,3.669,0,0,1-1.656-2.871A1.191,1.191,0,0,1,361.973,364.272Z",
    transform: "translate(-312.276 -362.08)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37421",
    "data-name": "Path 37421",
    d: "M361.973,364.272h.052l2.716-1.588.064-.036h0a1.191,1.191,0,0,1,1.12.139,3.657,3.657,0,0,1,1.656,2.871,1.16,1.16,0,0,1-.488,1.072h0l-2.748,1.588h0a1.191,1.191,0,0,1-1.148-.127,3.669,3.669,0,0,1-1.656-2.871A1.191,1.191,0,0,1,361.973,364.272Z",
    transform: "translate(-312.276 -362.08)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37422",
    "data-name": "Path 37422",
    d: "M363.156,366.755c-.913-.528-1.656-.1-1.656.953a3.669,3.669,0,0,0,1.656,2.871c.913.528,1.656.1,1.656-.957A3.661,3.661,0,0,0,363.156,366.755Z",
    transform: "translate(-312.256 -364.468)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37423",
    "data-name": "Path 37423",
    d: "M237.69,443.319h0l1.124-.675h0a.211.211,0,0,1,.218,0,.683.683,0,0,1,.306.528.21.21,0,0,1-.091.195h0l-1.12.679h0a.441.441,0,0,1-.206.052.429.429,0,0,1-.23-.794Z",
    transform: "translate(-237.485 -410.341)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37424",
    "data-name": "Path 37424",
    d: "M237.633,444.432h0l.06-.048h0a.214.214,0,0,1,.195.032.675.675,0,0,1,.306.528.206.206,0,0,1-.087.191h-.044a.33.33,0,0,1-.139.024.433.433,0,0,1-.433-.433.4.4,0,0,1,.143-.294Z",
    transform: "translate(-237.488 -411.402)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-2",
    transform: "translate(119.838 111.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-2-2",
    "data-name": "freepik--pencil--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37425",
    "data-name": "Path 37425",
    d: "M419.59,365.406l7.31-1.414a.226.226,0,0,1,.214.373l-4.979,5.583Z",
    transform: "translate(-377.577 -363.988)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37426",
    "data-name": "Path 37426",
    d: "M436.038,364.353a.226.226,0,0,0-.2-.353l-1.426.282h0a1.239,1.239,0,0,1,.588,1.163v.127Z",
    transform: "translate(-386.512 -363.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37427",
    "data-name": "Path 37427",
    d: "M331.711,392.64l.6-.341.723-.4,34.542-19.811a3.312,3.312,0,0,0-.2-2.422,3.407,3.407,0,0,0-2.355-2.128l-34.546,19.783-1.378.794C330.031,387.66,332.628,392.163,331.711,392.64Z",
    transform: "translate(-323.013 -366.129)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37428",
    "data-name": "Path 37428",
    d: "M337.447,419.4l1.334-.766c.4-.21.167-1.191-.294-2.176-.608-1.326-1.807-2.613-2.327-2.339l-.985.564-.345.21c.52-.278,1.719,1.009,2.327,2.339.441.957.663,1.89.33,2.14h0A.06.06,0,0,1,337.447,419.4Z",
    transform: "translate(-326.473 -394.193)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37429",
    "data-name": "Path 37429",
    d: "M336.255,420.1c.913-.484-1.707-5-2.621-4.511l-1.334.766c.913-.484,3.534,4.026,2.617,4.511Z",
    transform: "translate(-324.948 -395.075)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37430",
    "data-name": "Path 37430",
    d: "M331.741,422.668l1.318-.754c.9-.469-1.588-4.844-2.541-4.555l-.056.02-1.322.77C330.061,417.689,332.658,422.192,331.741,422.668Z",
    transform: "translate(-323.043 -396.158)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37431",
    "data-name": "Path 37431",
    d: "M375.272,364.107l-.234-.107-5.3,2.9L333.7,387.547c-.052-.079-.1-.087-.127-.032.794,1.215,1.366,2.744.854,3.01l.6-.341.723-.4,34.53-19.83h0l4.952-5.607a.226.226,0,0,0,.048-.242Z",
    transform: "translate(-325.714 -363.995)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37432",
    "data-name": "Path 37432",
    d: "M316.895,427.036l5.595-3.2c.4-.2.175-1.159-.278-2.156-.6-1.33-1.8-2.629-2.323-2.363h0l-5.615,3.216c-1.116.643-.091,3.065,1.152,4.146A1.326,1.326,0,0,0,316.895,427.036Z",
    transform: "translate(-313.791 -397.326)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37433",
    "data-name": "Path 37433",
    d: "M317.222,430.164a4.031,4.031,0,0,0-2.283-2.76.9.9,0,0,0-.838.111c-.842.794.139,3,1.314,4.026a1.338,1.338,0,0,0,1.441.369C317.277,431.665,317.444,431.022,317.222,430.164Z",
    transform: "translate(-313.785 -402.188)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    transform: "translate(40.762 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2-2",
    "data-name": "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2-3",
    "data-name": "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--speech-bubble--inject-2-4",
    "data-name": "freepik--speech-bubble--inject-2",
    d: "M258.312,63.9l6.016-3.145a36.443,36.443,0,0,0,10.193.6c9.431-.56,14.934-4.543,13.533-10.134-1.437-5.73-7.743-7.981-18.985-7.545-14.061.548-17.472,10.082-9.077,15.717Z",
    transform: "translate(-255.462 -43.627)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--speech-bubble--inject-2-5",
    "data-name": "freepik--speech-bubble--inject-2",
    d: "M258.312,63.9l6.016-3.145a36.443,36.443,0,0,0,10.193.6c9.431-.56,14.934-4.543,13.533-10.134-1.437-5.73-7.743-7.981-18.985-7.545-14.061.548-17.472,10.082-9.077,15.717Z",
    transform: "translate(-255.462 -43.627)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1069",
    "data-name": "Ellipse 1069",
    cx: 1.501,
    cy: 1.501,
    r: 1.501,
    transform: "translate(7.798 7.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1070",
    "data-name": "Ellipse 1070",
    cx: 1.501,
    cy: 1.501,
    r: 1.501,
    transform: "translate(14.85 7.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1071",
    "data-name": "Ellipse 1071",
    cx: 1.501,
    cy: 1.501,
    r: 1.501,
    transform: "translate(21.902 7.597)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsm);
export default __webpack_public_path__ + "static/media/stsm.94c8c77d1642d5f2469e3edb89c2e428.svg";
export { ForwardRef as ReactComponent };